export const trackingConstant = {
  TRACK_EVENT: 'TRACK_EVENT',
  SEND_TRACKING_DATA: 'SEND_TRACKING_DATA',
  ADD_TRACKING_DATA: 'ADD_TRACKING_DATA',
  REMOVE_TRACKING_DATA: 'REMOVE_TRACKING_DATA',
  OPIX_EVENT: 'OPIX_EVENT',
  REMOVE_OPIX_DATA: 'REMOVE_OPIX_DATA'
};
